module.exports = __webpack_public_path__ + "img/map-btn-lg.e9bf00ae.svg";